module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAtBAMAAAD8TT61AAAAAXNSR0IB2cksfwAAACFQTFRFAAAA////////////////////////////////////////zyHr+QAAAAt0Uk5TACxAFFeAKTAQYCBkl+ddAAAAO0lEQVR4nGNgwAKElEDAAJsUg2soCCSMyo14uSJwKmnAKjcVLLJgCMohfIUphxAZlRuscoj4Q7Cg5RkA2TTYV3JXZMoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-analytics@2x.png
// module id = 950
// module chunks = 0